<script>
/** Utilities */
import AppResourceUtil from '../utilities/AppResourceUtil'
import ArrayUtil from '../utilities/ArrayUtil'
/** APIs */
import UserApi from '../api/UserApi';
import IssueApi from '../api/IssueApi';
/** UI Components */
import { Checkbox } from 'buefy/dist/components/checkbox'
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Switch } from 'buefy/dist/components/switch'
import { Table,TableColumn } from 'buefy/dist/components/table'
import { Select } from 'buefy/dist/components/select'

export default {
    name : "CopyUserForm",
    components: {
        'b-checkbox' : Checkbox,
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-select' : Select,
        'b-switch' : Switch,
        'b-table' : Table,
        'b-table-column' : TableColumn,
    },
    props: {
        repGroupList : Array,
        rolesList : Array,
        data : Object,
        profile : Object
    },
    computed : {
        usernameErrorMessage() {
            if (this.invalidUsernameFormat == true) {
                return "Username should be in lowercase, at least 3 up to 16 characters long. No spaces and special characters ($%!@*#) allowed.";
            }
            if (this.usernameExists == true) {
                return "Username already exists. Please enter a new one."
            }
            if (this.validUsername == true) {
                return "Username is valid."
            }
            return "";
        },
        disableSubmit(){
            var oldData = {};
            var newData = {};
            for (var key in this.data) {
                if (key != 'tempData' && this.data.tempData.hasOwnProperty(key)) {
                    oldData[key] = this.data[key];
                }
            }
            for (var nkey in this.data.tempData) {
                newData[nkey] = this.data.tempData[nkey];
            }
            if (JSON.stringify(oldData)==JSON.stringify(newData)) {
                return false;
            }
            return true;
        },
        invalidForm(){
            let error = 0;
            if (this.data.tempData) {
                if (this.data.tempData.firstName=="" || this.data.tempData.lastName=="" || 
                    this.data.tempData.username=="" || this.data.tempData.email=="") {
                    error++
                }
                if (this.data.tempData.usernameExists==true ||
                    this.data.tempData.usernameValid==false) {
                    error++
                }
                if (this.data.tempData.email!=""){                
                    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                    if(this.data.tempData.email.match(mailformat)){      
                        // valid email                 
                    }
                    else {
                        error++;
                    }
                }
                if (this.data.tempData.roleId==null) {
                    error++;
                }
                else {
                    // if role is present
                    let res = this.rolesList.filter(role=>{
                        return role.roleId==this.data.tempData.roleId
                    });
                    if (res.length > 0) {
                        if (res[0].roleName!='Admin' && res[0].roleName!='Super Admin' &&
                            res[0].roleName!='Independent Administrator') {
                            // require rep entity if not Admin
                            if (this.data.tempData.repEntityId==null) {
                                error++;
                            }
                        }
                    }
                }    
            }
            if (error > 0) {
                return true
            }
            return false
        },
        isRoleAdmin(){
            let flag = false;
            if (this.data.tempData) {
                if (this.data.tempData.roleId!=null) {
                    // if role is present
                    let res = this.rolesList.filter(role=>{
                        return role.roleId==this.data.tempData.roleId
                    });
                    if (res.length > 0) {
                        if (res[0].roleName=='Admin' || res[0].roleName=='Super Admin' ||
                            res[0].roleName=='Independent Administrator') {
                            flag = true;                            
                        }
                    }
                }    
            }
            return flag;
        },
        allEntitiesOpts () {
            var entities = []
            if (this.repGroupList && this.repGroupList.length > 0) {
                this.repGroupList.forEach(grp => {
                    if (grp.reportingEntities.length > 0) {
                        entities = [
                            ...entities,
                            ...grp.reportingEntities        
                        ]
                    }
                })
            }
            return entities
        }
    },
    data(){
        return {
            newUsers : [],
            checkingUsername : false,
            usernameExists : false,
            validUsername : false,
            repEntityFieldLabel : "Reporting Entity",
            invalidUsernameFormat : false,
            emailInUse : false,
            emailError : "",
            invalidEmailFormat : false,
            globalError : {
                show : false,
                message : ""
            },
            errorFields : []
        }
    },
    created(){
        // Initial row
        // this.addRow();
    },
    methods : {
        usernameFormatOk(username) {
            if (username.match(/^[a-z0-9._-ñ]{4,16}$/gm)) {
                return true
            }
            return false
        },
        setErrorField(field) {
            let idx = ArrayUtil.getArrIndex(this.errorFields,field);
            if (idx==-1) {
                this.errorFields.push(field);
            }
        },
        removeErrorField(field) {
            let idx = ArrayUtil.getArrIndex(this.errorFields,field);
            if (idx!=-1) {
                this.errorFields.splice(idx,1);
            }
        },
        hasError(field){
            return ArrayUtil.inArray(this.errorFields,field)
        },
        checkName(field) {
            if (this.data.tempData[field].trim()!="") {
                this.removeErrorField(field);
            }
        },
        checkRole(){
            if (this.data.tempData.roleId!=null) {
                this.removeErrorField('roleId');
            }
        },
        checkRepEntity(){
            if (this.data.tempData.repEntityId!=null) {
                this.removeErrorField('repEntityId');
            }
        },
        checkRepEntityHandles(){
            if (this.data.tempData.repEntityHandles.length === 0) {
                /** 
                 * if there are no selected entities,
                 * clear/reset selected units as well
                 */
                this.data.tempData.repUnits = []
            } else {
                this.data.tempData.repUnits = []
                this.allEntitiesOpts.forEach(ent => {
                    if (ArrayUtil.inArray(this.data.tempData.repEntityHandles,ent.repEntityId)==true) {
                        if (ent.reportingUnits.length > 0) {
                            var repUnits = ent.reportingUnits.map(unit => {
                                return unit.repUnitId
                            })
                            this.data.tempData.repUnits = [
                                ...this.data.tempData.repUnits,
                                ...repUnits
                            ]    
                        }
                    }
                })
            }
        },
        checkUsername(){
            
            this.usernameExists = false;
            this.validUsername = false;
            this.invalidUsernameFormat = false;

            if (this.usernameFormatOk(this.data.tempData.username)==false) {
                this.invalidUsernameFormat = true;
                return false;
            }

            this.checkingUsername = true;
            if (this.data.tempData.username.length > 3 && 
                this.data.tempData.username!=this.data.username) {
                UserApi.checkUsername({
                    userId : this.data.tempData.userId,
                    username: this.data.tempData.username
                })
                .then(response=>{
                    if (response.data) {
                        if (!response.data.error) {
                            this.usernameExists = response.data.existing;
                            this.checkingUsername = false;
                            if (this.usernameExists==false) {
                                this.validUsername = true;
                                this.removeErrorField('username')
                            }
                        }
                        else {
                            this.promptServerError({response},'User.checkUsername');
                        }
                    }
                })
                .catch(error=>{
                    this.checkingUsername = false;
                    this.promptServerError(error,'User.checkUsername');
                })
            }
        },
        checkEmail(){

            this.emailInUse = false;
            this.invalidEmailFormat = false;
            this.emailError = "";
            
            if (this.data.tempData.email.trim()=="") {
                return false;
            }

            var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
            if(!this.data.tempData.email.match(mailformat)){   
                this.invalidEmailFormat = true;
                this.emailError = "Please check email format.";      
                return false        
            }

            UserApi.checkEmail({
                userId : this.data.tempData.userId,
                emailAddress: this.data.tempData.email
            })
            .then(response=>{
                
                if (response.data) {
                    if (!response.data.error) {
                        if (response.data.existing==true) {
                            this.emailInUse = true;
                            this.emailError = `${this.data.tempData.email} is already in use.`;
                        }
                        else {
                            this.removeErrorField('email')
                        }
                    }
                    else {
                        this.promptServerError({response},'User.checkEmail');
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'User.checkEmail');
            })
        },
        unitsOf(user) { 
            var units = []
            this.repGroupList.forEach(group=>{
                group.reportingEntities.forEach(entity=>{
                    if (ArrayUtil.inArray(user.repEntityHandles, entity.repEntityId)) {
                        units = [
                            ...units,
                            ...entity.reportingUnits
                        ]
                    }
                    /* Old implementation
                    if (entity.repEntityId==repEntityId) {
                        units = entity.reportingUnits;
                    } */
                })
            });

            if (user.selectedUnitsOnly === true) {
                return units.filter(unit => {
                    return ArrayUtil.inArray(user.repUnits, unit.repUnitId)
                })
            }
            return units
        },
        closeError(){
            this.globalError.show = false;
            this.globalError.message = "";
        },
        showError(msg) {
            this.globalError.show = true;
            this.globalError.message = msg;  
        },
        triggerClose(){
            let withData = this.hasUserData();
            if (withData) {
                this.$dialog.confirm({
                    title: "You have unsaved changes",
                    message: "Changes will not be saved once you click 'Close form'. What do you want to do?",
                    cancelText: "Close form",
                    confirmText: "Continue editing",
                    type: 'is-warning',
                    onConfirm: () => {
                    },
                    onCancel: ()=>{
                        this.$emit('close');
                    }
                });
            }            
        },
        triggerSubmit(){

            this.closeError();

            this.errorFields = [];

            if (this.data.tempData) {
                if (this.data.tempData.firstName.trim()=="") {
                    this.setErrorField('firstName');
                } 
                if (this.data.tempData.lastName.trim()=="") {
                    this.setErrorField('lastName');
                } 
                if (this.data.tempData.username.trim()=="") {
                    this.setErrorField('username');
                } 
                else {
                    if (this.usernameFormatOk(this.data.tempData.username)==false) {
                        this.setErrorField('username');
                    }
                    else {
                        if (this.data.tempData.usernameExists==true ||
                            this.data.tempData.usernameValid==false) {
                            this.setErrorField('username');
                        }
                    }
                }

                if (this.data.tempData.email.trim()=="") {
                    this.setErrorField('email');
                } 
                else {
                    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                    if(!this.data.tempData.email.match(mailformat)){   
                        this.setErrorField('email');
                    }
                    else if (this.emailInUse==true) {
                        this.setErrorField('email');
                    }
                }
                
            
                if (this.data.tempData.roleId==null) {
                    this.setErrorField('roleId');
                }
                else {
                    // if role is present
                    let res = this.rolesList.filter(role=>{
                        return role.roleId==this.data.tempData.roleId
                    });
                    if (res.length > 0) {
                        if (res[0].roleName!='Admin' && res[0].roleName!='Super Admin' &&
                            res[0].roleName!='Independent Administrator') {
                            // require rep entity if not Admin
                            // if (this.data.tempData.repEntityId==null) {
                            //     this.setErrorField('repEntityId');
                            // }
                            if (this.data.tempData.repEntityHandles.length === 0) {
                                this.setErrorField('repEntityHandles');
                            }
                        }
                    }
                }    
            }

            if (this.errorFields.length > 0) {
                this.showError('Please check your inputs and fill out the mandatory fields.')
                return false;
            }

            this.$emit('save-profile-copy',this.data.tempData);
        },
        triggerAddRepUnit() {
            this.$dialog.confirm({
                title: 'Warning',
                message: 'This action will navigate away from this page and you may lose your unsaved data. To continue editing, click \'Continue Edit\'. Otherwise, click \'Confirm and Add Unit\'. ',
                cancelText: 'Continue Edit',
                confirmText: 'Confirm and Add Unit',
                type: 'is-warning',
                onConfirm: () => this.gotoAddRepUnit()
            });
        },
        gotoAddRepUnit(){
            var selectedEntity = null;
            this.repGroupList.forEach(group=>{
                group.reportingEntities.forEach(entity=>{
                    if (entity.repEntityId==this.data.tempData.repEntityId) {
                        selectedEntity = entity;
                    }
                });
            });
            if (selectedEntity) {
                window.open(window.location.origin+"/#/admin/reporting-groups?action=addRepUnit&repEntityId="+selectedEntity.repEntityId+"&repEntity="+selectedEntity.reportingEntity)
            }
        },
        checkRepEntityLabel(roleId) {
            let label = "Reporting Entity";
            let res = this.rolesList.filter(role=>{
                return role.roleId==roleId
            });
            if (res.length > 0) {
                if (res[0].roleName!='Admin' && res[0].roleName!='Super Admin' &&
                    res[0].roleName!='Independent Administrator') {
                    label = "*"+label;
                }
                else {
                    // if Admin - update repEntity and repUnits
                    this.data.tempData.repEntityId = null;

                    this.data.tempData.repEntityHandles = [];
                    this.data.tempData.repUnits = [];
                }
            }
            this.repEntityFieldLabel = label;
        },
        hasUserData(){
            if (this.data.tempData) {
                if (this.data.tempData.firstName!=="" || this.data.tempData.lastName!=="" || 
                    this.data.tempData.username!=="" || this.data.tempData.emailAddress!=="") {
                    return true
                }
                if (this.data.tempData.roleId!==null || 
                    this.data.tempData.repEntityId!==null) {
                    return true
                }
                return false
            }
        },
        submitError(errorData,api){   
            let obj = {
                email : this.profile.email,
                username : this.profile.username,
                message : "["+errorData.type+" "+errorData.code+"] - "+errorData.message+" Request to: "+api,
                issueStatus : "Pending",
                issueType : "Issue",
                createdBy : this.profile.userId,
                pageName : this.$route.name,
                pageLink : this.$route.path
            };

            if (errorData.hasOwnProperty('query')) {
                obj.message += ' SQL Query: '+errorData.query;
            }

            // Add feedback/issue to DB
            IssueApi.add(obj)
            .then(response=>{
                if (response.data) {
                    if (response.data.issueId) {
                        this.$dialog.alert({
                            title: 'Success',
                            message: "<p><strong>Thanks for reporting!</strong></p><br/>  Admin will check this and get back to you, if necessary.",
                            type: 'is-success'
                        });
                    }
                    else {
                        this.$dialog.alert({
                            title: 'Error',
                            message: "Unable to submit error. Please try again later.",
                            type: 'is-danger'
                        });
                    }
                }
            })
            .catch(error=>{
                this.promptServerError(error,'Issue.add');
            });
        },
        promptServerError(error,api){
            try {
                let returnData = AppResourceUtil.getErrorData(error.response);
                if (returnData.errorData!=null) {
                    this.$dialog.confirm({
                        title: returnData.dialog.title,
                        message: returnData.dialog.message,
                        cancelText: "Close",
                        confirmText: "Submit Error",
                        type: 'is-danger',
                        onConfirm: () => {
                            this.submitError(returnData.errorData,api);
                        }
                    });
                }
            } 
            catch(respError){
                console.log(respError)
            }
        },
        filterEntities (user) {
            if (this.allEntitiesOpts) {
                try {
                    var filtered = this.allEntitiesOpts
                    if (user.handleKeyword && user.handleKeyword.trim().length > 0) {
                        var regExp = new RegExp(user.handleKeyword, 'i')
                        filtered = this.allEntitiesOpts.filter(ent => {
                            return ent.reportingEntity.match(regExp)
                        })
                    }
                    if (user.selectedEntitiesOnly === true) {
                        return filtered.filter(ent => {
                            return (ArrayUtil.inArray(user.repEntityHandles,ent.repEntityId))
                        })
                    }
                    return filtered
                } catch(err) {
                    console.log(err)
                }
            }
            return this.allEntitiesOpts
        }
    }
}
</script>

<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Copy Profile</p>
        </header>

        <section class="modal-card-body">

            <div class="has-text-left is-italic">
                Fields marked with * are mandatory.
            </div>

            <div class="notification is-danger"
                v-if="globalError.show">
                <button class="delete"
                    type="button"
                    v-on:click="closeError"></button>
                <p>{{globalError.message}}</p>
            </div>
            
            <div class="box">

                <b-field
                    label="*First Name"
                    expanded
                    :type="{'is-danger':hasError('firstName') || !data.tempData.firstName}">
                    <b-input 
                        v-model="data.tempData.firstName"
                        type="text"
                        value=""
                        required
                        v-on:blur="checkName('firstName')"></b-input>
                </b-field>

                <b-field
                    label="*Last Name"
                    expanded
                    :type="{'is-danger':hasError('lastName') || !data.tempData.lastName}">
                    <b-input 
                        v-model="data.tempData.lastName"
                        type="text"
                        required
                        v-on:blur="checkName('lastName')"></b-input>
                </b-field>

                <b-field
                    label="*Username"
                    v-bind:type="{
                        'is-danger':usernameExists || invalidUsernameFormat || hasError('username'),
                        'is-success':validUsername
                    }"
                    v-bind:message="usernameErrorMessage">
                    <b-input 
                        v-model="data.tempData.username"
                        type="text"
                        required
                        v-bind:loading="checkingUsername"
                        v-on:blur="checkUsername"></b-input>
                </b-field>

                <b-field
                    label="*Email Address"
                    expanded
                    :type="{
                        'is-danger': invalidEmailFormat || emailInUse || hasError('email') || 
                        !data.tempData.email
                    }"
                    :message="emailError">
                    <b-input 
                        v-model="data.tempData.email"
                        type="email"
                        required
                        v-on:blur="checkEmail"></b-input>
                </b-field>
                
                <b-field
                    label="*Role"
                    :type="{'is-danger':hasError('roleId')}">
                    <b-select
                        v-model="data.tempData.roleId"
                        v-on:input="checkRepEntityLabel(data.tempData.roleId)"
                        v-on:blur="checkRole">
                        <option v-for="role in rolesList" 
                            v-bind:key="role.roleId"
                            v-bind:value="role.roleId">{{role.roleName}}</option>
                    </b-select>
                </b-field>

                <!-- <b-field
                    v-bind:label="repEntityFieldLabel"
                    :type="{'is-danger':hasError('repEntityId')}">
                    <b-select
                        v-model="data.tempData.repEntityId"
                        v-bind:disabled="isRoleAdmin"
                        v-on:blur="checkRepEntity">
                        <optgroup 
                            v-for="(group,groupIdx) in repGroupList"
                            v-bind:key="groupIdx"
                            v-bind:label="group.reportingGroup">
                            <option v-for="entity in group.reportingEntities" 
                                v-bind:key="entity.repEntityId"
                                v-bind:value="entity.repEntityId">
                                {{entity.reportingEntity}}
                            </option>
                        </optgroup>
                    </b-select>
                </b-field> -->

                <div>
                    <b-field
                        grouped>
                        <b-field 
                            expanded
                            label="Choose Reporting Entities">
                            <b-input 
                                v-model="data.tempData.handleKeyword"
                                placeholder="Enter keyword"
                                type="search"
                                icon="magnify"
                                style="margin:0.4rem;">
                            </b-input>
                        </b-field>
                        <b-field
                            label=""
                            style="margin-top:2.3rem">
                            <b-switch v-model="data.tempData.selectedEntitiesOnly">
                                Selected Only
                            </b-switch>
                        </b-field>
                    </b-field>

                    <div 
                        class="has-text-danger"
                        v-if="hasError('repEntityHandles')"
                        style="margin-bottom:0.4rem;">
                        Reporting Entity is required.
                    </div>

                    <div 
                    style="max-height:165px;overflow-y:scroll">
                        <ul v-if="filterEntities(data.tempData).length > 0"
                            style="margin-left:0.8rem;">
                            <li v-for="entity in filterEntities(data.tempData)" 
                                v-bind:key="entity.repEntityId">
                                <b-checkbox 
                                    v-model="data.tempData.repEntityHandles"
                                    v-bind:native-value="entity.repEntityId"
                                    v-on:input="checkRepEntityHandles">
                                    {{entity.reportingEntity}} 
                                    &nbsp;
                                    <span
                                        class="tag" 
                                        :class="entity.repGroupTagClass">
                                        {{entity.reportingGroup}}
                                    </span>
                                </b-checkbox>
                            </li>
                        </ul>
                        <div v-else>
                            <span>No data found.</span>
                        </div>
                    </div>

                    <div v-if="!data.tempData.repEntityHandles || data.tempData.repEntityHandles.length===0"
                                style="padding-left:1rem;margin-bottom:1rem;margin-top:0.6rem">
                        <p>No data selected.</p>
                    </div>
                </div>

                
                <div class="control"
                    style="margin-top:12px">

                    <div>
                        <b-field
                            label="Reporting Units"
                            style="margin-left:0.2rem;">
                            <b-switch v-model="data.tempData.selectedUnitsOnly">
                                Selected Only
                            </b-switch>
                        </b-field>

                        <div 
                            style="max-height:165px;overflow-y:scroll">
                            <ul v-if="unitsOf(data.tempData) && unitsOf(data.tempData).length > 0"
                                style="margin-left:0.8rem;">
                                <li v-for="unit in unitsOf(data.tempData)"
                                    v-bind:key="unit.repUnitId"
                                    style="vertical-align:top; margin-bottom:0.7rem">
                                    <b-checkbox 
                                        v-model="data.tempData.repUnits"    
                                        v-bind:native-value="unit.repUnitId"
                                        style="vertical-align:top">
                                        <p>{{unit.reportingEntity}}  -</p>
                                        {{unit.reportingUnit}} 
                                    </b-checkbox>
                                </li>
                            </ul>
                            <div v-else
                                style="padding-left:1rem;margin-bottom:1rem">
                                <span>No data found.</span>
                            </div>
                        </div>
                    </div>

                    <!-- <b-field
                        label="Reporting Unit">
                        <div class="block"
                            v-if="unitsOf(data.tempData.repEntityId).length > 0">
                            <b-checkbox 
                                v-model="data.tempData.repUnits"
                                v-for="unit in unitsOf(data.tempData.repEntityId)"
                                v-bind:key="unit.repUnitId"
                                v-bind:native-value="unit.repUnitId">
                                {{unit.reportingUnit}}
                            </b-checkbox>
                        </div>
                    </b-field>
                    <div class="block"
                        v-if="data.tempData.repEntityId">
                        <a class="button is-text"
                            type="button"
                            v-on:click="triggerAddRepUnit">
                            
                            <span>Add Reporting Unit</span>
                        </a>
                        <p v-if="data.tempData.repEntityId"><br/></p>
                    </div> -->
                </div>

                <b-field
                    label="Active">
                    <b-switch v-model="data.tempData.isActive">
                        {{data.tempData.isActive==true ? "Yes" : "No" }}
                    </b-switch>
                </b-field>

            </div>
        
        </section>

        <footer class="modal-card-foot has-text-left">

            <a class="button is-white"
                v-on:click="triggerClose">
                <span>Cancel</span>
            </a>
            
            <a class="button is-success"
                v-on:click="triggerSubmit">
                <!-- v-bind:disabled="invalidForm" -->
                <span>Submit</span>
            </a>
        </footer>
    </div>
</template>

<style scoped>
fieldset {
    border: 1px solid #d3d3d3;
    padding: 0.75em 0.65em 1.35em 0.65em;
    border-radius: 4px;
    margin-bottom: 0.75em;
}
</style>





// WEBPACK FOOTER //
// src/components/CopyUserForm.vue